import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/react'
import { FormLayout } from '@/components/template/form-layout'
import { ReservationGuestRoomLabel } from '@/components/atoms/reservation-guest-room-label'
import { textOverflowStyle } from '@/styles/common'
import { SurveySkip } from '@/components/organisms/survey/survey-skip'
import { Divider } from '@/components/atoms/divider'
import { useAppSelector } from '@/app/hooks'

type Props = {
  hotelId: string
}

export const CheckoutReservationList: React.FC<Props> = ({ hotelId }) => {
  const { t } = useTranslation()
  const checkoutReservations = useAppSelector(state => state.checkout.checkoutReservation.checkoutReservations)
  const survey = useAppSelector(state => state.survey.surveyQuestions.survey)

  return (
    <div css={checkoutReservationLayoutStyle}>
      <FormLayout>
        <ul>
          {checkoutReservations.map((reservation, index) => (
            <li key={index} css={checkoutReservationListItemStyle}>
              <p css={roomTextStyle}>
                <ReservationGuestRoomLabel roomNumbers={reservation.roomNumbers} />
              </p>
              <p css={reservationIdStyle}>
                <span>{t('Reservation ID')}</span>
                <span css={textOverflowStyle}>{reservation.reservationId}</span>
              </p>
            </li>
          ))}
        </ul>
      </FormLayout>
      {survey && (
        <>
          <Divider />
          <SurveySkip reservationIds={survey.reservationIds} hotelId={hotelId} />
        </>
      )}
    </div>
  )
}

const checkoutReservationLayoutStyle = css({
  marginBottom: '1rem',
})

const roomTextStyle = css({
  fontWeight: 'bold',
})

const checkoutReservationListItemStyle = css({
  borderBottom: '1px solid #F2F2F2',
  paddingBottom: '1.5rem',
  marginBottom: '1.5rem',
  '&:last-of-type': {
    border: 'none',
    paddingBottom: 0,
    marginBottom: 0,
  },
})

const reservationIdStyle = css({
  display: 'flex',
  marginTop: '0.5rem',
  fontSize: '12px',
  span: {
    '&:first-of-type': {
      flexBasis: '48px',
    },
  },
})
